import { Navigate, useLocation } from "react-router-dom";

import { careerProfilePathFromLegacy } from "../careerPlanRedirect";

export default function CareerPlanLegacyAssessmentRedirect() {
  const location = useLocation();
  return <Navigate to={careerProfilePathFromLegacy(location.pathname, location.search)} replace />;
}
